import React, { useState } from 'react';
import { formatNumber } from 'utils/formatter';
import { useScroll } from 'hooks/useScroll';
import { DividendDetailInfo } from '../dividendDetailPrediction/DividendDetailInfo';
import {
  DividendListProps,
  DividendListItemProps,
} from '../dividendPrediction/DividendClassification';
import { getSummaryDividendHaito } from '../dividendPrediction/DividendTransition';
import {
  AccountTypeLabelList,
  sortDividendListAccountType,
} from '../dividendPrediction/DividendSymbolList';

const DividendDetailItem = ({
  data,
  isTaxDeduction,
}: {
  data: DividendListProps;
  isTaxDeduction: boolean;
}) => {
  const sortedDividendItems = sortDividendListAccountType(
    data.items
  ) as DividendListItemProps[];
  const sortedDividendData = {
    ...data,
    items: sortedDividendItems,
  } as DividendListProps;

  const summaryHaito = getSummaryDividendHaito(data.items, isTaxDeduction);

  const isIncludeUnreleasedDividend = data.items.some(
    item =>
      item.unreleasedStatus === 'all' || item.unreleasedStatus === 'not_all'
  );
  const isAllUnreleasedDividend = data.items.every(
    item => item.unreleasedStatus === 'all'
  );
  const unreleasedStatus =
    !isIncludeUnreleasedDividend && !isAllUnreleasedDividend
      ? 'not_exist'
      : isIncludeUnreleasedDividend && !isAllUnreleasedDividend
      ? 'not_all'
      : 'all';

  const isHasNew = data.items.some(item => item.hasNew);

  // 配当詳細スライド
  const [showDetailInfo, setShowDetailInfo] = useState<boolean>(false);
  const [hideAnimate, setHideAnimate] = useState<boolean>(false);

  const detailInfoShow = (): void => {
    setShowDetailInfo(true);
    setHideAnimate(false);
  };

  const detailInfoHide = (): void => {
    setShowDetailInfo(false);
  };

  const detailInfoHideAnimate = (): void => {
    setHideAnimate(true);
  };

  return (
    <>
      <div className="px-4 py-3 border-b border-gray-300">
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="ml-2">
            <div className="flex flex-row">
              <div className="text-xs text-bluegray-500">{data.symbol}</div>
              <AccountTypeLabelList {...{ list: sortedDividendData.items }} />
            </div>
            <div className="flex flex-col line-clamp-2">
              <div className="mt-2 font-bold text-bluegray-700">
                {data.symbolName}
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center">
            <div className="ml-auto" style={{ whiteSpace: 'nowrap' }}>
              <div className="flex flex-col">
                <div
                  className={`${
                    unreleasedStatus === 'all'
                      ? 'text-bluegray-400'
                      : 'text-bluegray-700'
                  }`}>
                  {formatNumber(summaryHaito, {})}
                  <span className="ml-1 text-xs">円</span>
                </div>
                {unreleasedStatus !== 'not_exist' ? (
                  <div className="ml-auto text-1.5xs text-bluegray-400">
                    (未発表
                    {unreleasedStatus === 'not_all' ? '含む' : ''})
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div
              className="flex items-center justify-center w-10 ml-2 cursor-pointer"
              onClick={
                !showDetailInfo ? detailInfoShow : detailInfoHideAnimate
              }>
              <img src="/static/images/dividendInfo_button.svg" alt="" />
              {isHasNew ? (
                <span className="rounded-full h-2 w-2 bg-tradewell -mt-5 -ml-2 z-10"></span>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-end mr-2 text-xs text-bluegray-500">
          <div className="ml-2">
            数量<span className="ml-2">{formatNumber(data.totalQty, {})}</span>
            <span className="ml-1">株</span>
          </div>
        </div>
      </div>
      {showDetailInfo ? (
        <DividendDetailInfo
          {...{
            detailInfoHide,
            hideAnimate,
            dividendData: data,
            symbol: data.symbol,
            isTaxDeduction,
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export const DividendSymbolList = ({
  displayDividendList,
  totalDividend,
  isTaxDeduction,
}: {
  displayDividendList: DividendListProps[];
  totalDividend: number;
  isTaxDeduction: boolean;
}) => {
  useScroll();
  return (
    <>
      <div
        className="grid mt-4 px-4 py-1 text-sm text-bluegray-550 font-bold bg-gray-300"
        style={{ gridTemplateColumns: '1fr 1fr' }}>
        <div className="ml-2">銘柄</div>
        <div>予想額</div>
      </div>
      {displayDividendList.map((data, i) => (
        <DividendDetailItem {...{ data, isTaxDeduction }} key={i} />
      ))}
      <div className="flex flex-row items-center pl-6 pr-4 pt-2 pb-8">
        <div className="font-bold">合計</div>
        <div className="ml-auto">
          <span className="mr-1 text-lg font-bold">
            {formatNumber(totalDividend, {})}
          </span>
          円
        </div>
      </div>
    </>
  );
};
